import Vue from 'vue'
import VueRouter from 'vue-router'
import Ps from 'perfect-scrollbar/jquery'
import $ from 'jquery'
import Icon from 'vue-awesome'

import App from './App'
import Index from './components/Index'
import About from './components/About'
import Social from './components/Social'
import Link from './components/Link'

Ps($)

Vue.use(VueRouter);
Vue.component('Icon', Icon)

var router = new VueRouter()

router.map({
  '/about': {
    component: About
  },
  '/social': {
    component: Social
  },
  '/link': {
    component: Link
  },
  '/': {
    component: Index
  }
})

router.start(App, 'App')




// WEBPACK FOOTER //
// ./src/main.js